/**
 * SL4 cart drawer cross-sell: "Agregar" button on the single suggested
 * product. Adds the default variant via the AJAX cart API and reuses Dawn's
 * own cart-drawer refresh routine (cart-drawer.renderContents) so the drawer
 * (including this same upsell block, freshly re-evaluated) updates in place
 * without navigating to the PDP.
 *
 * Delegated on document because the button is re-created every time Dawn
 * swaps the drawer markup on cart updates.
 */
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-sl4-add-suggestion]');
  if (!button) return;

  event.preventDefault();
  if (button.getAttribute('aria-disabled') === 'true') return;

  var variantId = button.dataset.variantId;
  if (!variantId) return;

  var cartDrawer = document.querySelector('cart-drawer');

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('sl4-cart-upsell__add-btn--loading');

  var body = JSON.stringify({
    id: variantId,
    quantity: 1,
    sections: cartDrawer ? cartDrawer.getSectionsToRender().map(function (section) {
      return section.id;
    }) : undefined,
    sections_url: window.location.pathname,
  });

  fetch(window.routes.cart_add_url, Object.assign(fetchConfig(), { body: body }))
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      if (data.status) {
        console.error(data);
        return;
      }

      if (cartDrawer) {
        cartDrawer.renderContents(data);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sl4-cart-upsell', cartData: data });
      }
    })
    .catch(function (error) {
      console.error(error);
    })
    .finally(function () {
      button.removeAttribute('aria-disabled');
      button.classList.remove('sl4-cart-upsell__add-btn--loading');
    });
});
